import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "flex w-full flex-col" };
var _hoisted_2 = ["for"];
var _hoisted_3 = { class: "flex items-center space-x-2.5" };
import { computed, useSlots } from 'vue';
import EHelp from '@common/ui/EHelp.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ELabel',
    props: {
        name: {},
        label: {},
        size: { default: 'md' },
        weight: { default: 'normal' },
        labelable: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        position: { default: 'left' },
        helpText: {}
    },
    setup: function (__props) {
        var slots = useSlots();
        var props = __props;
        var textSize = computed(function () {
            return {
                sm: 'text-sm',
                md: 'text-md',
                lg: 'text-lg',
                xl: 'text-xl'
            }[props.size];
        });
        var textWeight = computed(function () {
            return {
                normal: 'font-normal',
                medium: 'font-medium',
                bold: 'font-bold'
            }[props.weight];
        });
        var textPosition = computed(function () {
            return {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
            }[props.position];
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.label || _unref(slots).label)
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: _normalizeClass([[
                                textPosition.value,
                                textSize.value,
                                textWeight.value,
                                _ctx.disabled && 'text-gray-300'
                            ], "mb-2"]),
                        for: _ctx.labelable ? _ctx.name : undefined
                    }, [
                        _renderSlot(_ctx.$slots, "label", {}, function () { return [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.label), 1),
                                (_ctx.helpText)
                                    ? (_openBlock(), _createBlock(EHelp, {
                                        key: 0,
                                        text: _ctx.helpText
                                    }, null, 8, ["text"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]; })
                    ], 10, _hoisted_2))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
